import { Delete, Save } from '@mui/icons-material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { IconButton, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { createStyles, makeStyles } from '@mui/styles';
import React, { useId, useRef } from 'react';

interface UploaderInLineProps {
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  uploadedFileName: string;
  handleSave: () => Promise<void>;
  handleClearFile: () => void;
  disabled?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    contentContainer: {
      width: '500px',
      height: 260,
    },
    input: {
      display: 'none',
    },
    icon: {
      marginLeft: theme.spacing(1),
    },
    uploadText: {
      borderRadius: '5px',
      fontWeight: 'bold',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  }),
);

function UploaderInLine(props: UploaderInLineProps) {
  const uniqueId = useId();
  const classes = useStyles();
  const {
    handleFileChange,
    uploadedFileName,
    handleSave,
    handleClearFile,
    disabled,
  } = props;
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleClearFileWithReset = () => {
    handleClearFile();
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  return (
    <div>
      <input
        ref={fileInputRef}
        className={classes.input}
        id={`contained-button-file-${uniqueId}`}
        type="file"
        onChange={handleFileChange}
        disabled={disabled}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {uploadedFileName && (
          <div className={classes.uploadText}>
            <Typography>{uploadedFileName}</Typography>
            <IconButton onClick={() => void handleClearFileWithReset()}>
              <Delete color="error" />
            </IconButton>
            <IconButton onClick={() => void handleSave()}>
              <Save color="primary" />
            </IconButton>
          </div>
        )}
        <IconButton disabled={disabled}>
          <label
            htmlFor={`contained-button-file-${uniqueId}`}
            style={{
              cursor: disabled ? 'default' : 'pointer',
              paddingTop: 4,
            }}
          >
            <span>
              <CloudUploadIcon color={disabled ? 'disabled' : 'action'} />
            </span>
          </label>
        </IconButton>
      </div>
    </div>
  );
}

export default UploaderInLine;
